import React from 'react';

import Divider from 'material-ui/Divider';
import Drawer from 'material-ui/Drawer';
import Feedback from 'material-ui/svg-icons/action/feedback';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'material-ui/MenuItem';

import * as Version from './version';
import './scenes/Navigation/styles/navigation.css';

import * as Colors from './styles/colors';

const menuItemInnerStyles = {
  paddingLeft: 56,
};

const menuItemStyles = {
  fontSize: 13,
  fontWeight: 500,
  color: Colors.textColor,
};

const selectedMenuItemStyles = {
  fontSize: 13,
  fontWeight: 500,
  color: Colors.peterRiver,
};

function DrawerHeader(props) {
  return (
    <div className='drawer-header'>
      <img className='drawer-header__logo' alt='iHomework Icon' src="icon-128x128.png"/>
      <h3 className='drawer-header__title'>iHomework</h3>
    </div>
  )
};

function NavigationDrawer(props) {
  const selectedScene = props.selectedScene;

  return (
    <Drawer 
      open={props.isOpen}
      docked={false}
      onRequestChange={props.onRequestChange}>
        <DrawerHeader />
        <MenuItem 
          primaryText="Assignments" 
          innerDivStyle={menuItemInnerStyles} 
          style={ selectedScene === 0 ? selectedMenuItemStyles : menuItemStyles } 
          leftIcon={ selectedScene === 0 ? <img src="menu-item-assignments-selected.png" alt="Assignments" /> : <img src="menu-item-assignments-normal.png" alt="Assignments"/>} 
          onClick={() => props.onSceneChange(0)} />
        <MenuItem 
          primaryText="Planner" 
          innerDivStyle={menuItemInnerStyles} 
          style={ selectedScene === 1 ? selectedMenuItemStyles : menuItemStyles }
          leftIcon={ selectedScene === 1 ? <img src="menu-item-planner-selected.png" alt="Planner"/> : <img src="menu-item-planner-normal.png" alt="Planner"/>} 
          onClick={() => props.onSceneChange(1)}/>
        <MenuItem 
          primaryText="Organizer" 
          innerDivStyle={menuItemInnerStyles} 
          style={ selectedScene === 2 ? selectedMenuItemStyles : menuItemStyles }
          leftIcon={selectedScene === 2 ? <img src="menu-item-organizer-selected.png" alt="Organizer"/> : <img src="menu-item-organizer-normal.png" alt="Organizer" />} 
          onClick={() => props.onSceneChange(2)}/>
        <Divider />
        <MenuItem 
          primaryText="Account" 
          innerDivStyle={menuItemInnerStyles} 
          style={menuItemStyles}
          leftIcon={<FontIcon className="material-icons" color="#424242">account_circle</FontIcon>} 
          onClick={() => props.onDetailSceneChange(0)} />
        {/*
        <MenuItem 
          primaryText="Settings" 
          innerDivStyle={menuItemInnerStyles} 
          style={menuItemStyles}
          leftIcon={<FontIcon className="material-icons" color="#424242">settings</FontIcon>} 
          onClick={() => props.onDetailSceneChange(1)} />
        */}
        <MenuItem
          primaryText="Feedback"
          innerDivStyle={menuItemInnerStyles}
          style={menuItemStyles}
          leftIcon={ <Feedback color="#424242" /> }
          onClick={() => location.href="mailto:paulsapps@pilone.org?subject=iHomework 2 Web Feedback"} />

        <div className='app-version'>
          {Version.version}
        </div>
    </Drawer>
  )
  
}

export default NavigationDrawer;


// WEBPACK FOOTER //
// ./src/NavigationDrawer.js